// extracted by mini-css-extract-plugin
export default {"highlightTxt":"t4Pic","highlightBtn":"GgCFa","highlightButtons":"RqSUv","desktopHighlight":"an0d6"};